export const idTypeMap = {
    cuit: 'cuit',
    cuil: 'cuil',
    cnpj: 'cnpj',
    cpf: 'cpf',
    cc: 'c.c.',
    rut: 'rut',
    ce: 'c.e.',
    nit: 'nit',
    ruc: 'ruc',
    dimex: 'dimex',
    cedula: 'cedula',
    rfc: 'rfc',
    ci: 'c.i.',
    dni: 'dni',
};
export function normalizeIdType(value = '') {
    const key = value.trim().toLowerCase().replaceAll('.', '').replaceAll('-', ' ').replaceAll('_', ' ');
    return idTypeMap[key] || value;
}
export function normalizeAccountType(value = '') {
    const normalizedValue = value.trim().toLowerCase().replaceAll('.', '').replaceAll('-', ' ').replaceAll('_', ' ');
    if (normalizedValue.includes('ahorro') || normalizedValue.includes('vista')) {
        return 'Cta Ahorros';
    }
    if (normalizedValue.includes('corriente')) {
        return 'Cta Corriente';
    }
    if (normalizedValue.includes('virtual') || normalizedValue.includes('digital')) {
        return 'Cta Virtual';
    }
    if (normalizedValue.includes('clabe') || normalizedValue.includes('interbancaria')) {
        return 'CLABE Interbancaria';
    }
    return undefined;
}
export function normalizeBankingEntity(bankName = '', bankList = []) {
    if (!bankName || bankList.length === 0) {
        return undefined;
    }
    const normalizedBankName = bankName
        .trim()
        .toLowerCase()
        .replaceAll('.', '')
        .replaceAll('-', ' ')
        .replaceAll('_', ' ');
    let cleanBankName = normalizedBankName;
    if (normalizedBankName.startsWith('banco ')) {
        cleanBankName = normalizedBankName.replace('banco ', '');
    }
    else if (normalizedBankName.endsWith(' banco')) {
        cleanBankName = normalizedBankName.replace(' banco', '');
    }
    const partialMatch = bankList.find((bank) => {
        const normalizedBankListName = bank.name
            .toLowerCase()
            .replaceAll('.', '')
            .replaceAll('-', ' ')
            .replaceAll('_', ' ');
        return (normalizedBankListName.includes(cleanBankName) ||
            cleanBankName.includes(normalizedBankListName) ||
            normalizedBankListName.includes(normalizedBankName) ||
            normalizedBankName.includes(normalizedBankListName));
    });
    if (partialMatch) {
        return partialMatch.id;
    }
    return undefined;
}
